// extracted by mini-css-extract-plugin
export default {"checkbox":"StatusHeader_checkbox__4LI0U","placeHolderShimmer":"StatusHeader_placeHolderShimmer__uO79c"};